export default __webpack_public_path__ + "static/media/pledge.4a737f43.png";